let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9IQk0")).then(() => parcelRequire('geoU0'));